import { Backdrop, CircularProgress } from "@mui/material";
import React from "react";

export interface ILoadingScreenProps {
  open: boolean;
}

export default function LoadingScreen(props: ILoadingScreenProps) {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={props.open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
